import { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Typography,
  CircularProgress,
} from '@mui/material';

export interface MemberType {
  id: number;
  name: string;
  display_name: string;
  weight: number;
}

interface HoHTransferDialogProps {
  open: boolean;
  newHohName: string;
  currentHeadName: string;
  roleOptions: MemberType[];
  value: MemberType | null;
  onChange: (value: MemberType | null) => void;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const HoHTransferDialog: FC<HoHTransferDialogProps> = ({
  open,
  newHohName,
  currentHeadName,
  roleOptions,
  value,
  onChange,
  loading = false,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Transfer household ownership</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          You are about to transfer the Head of Household role to{' '}
          <strong style={{ textTransform: 'capitalize' }}>{newHohName}.</strong>
          <br />
          <br />
          <strong>Important:</strong>
          <br />
          Once this transfer is complete, you will no longer be able to manage
          this household.
          <br />
          <strong style={{ textTransform: 'capitalize' }}>
            {newHohName}
          </strong>{' '}
          will be able to edit, add and remove members to this household.
        </DialogContentText>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
          <strong style={{ textTransform: 'capitalize' }}>
            {currentHeadName}
          </strong>{' '}
          will become:
        </Typography>
        <Autocomplete
          options={roleOptions}
          getOptionLabel={(option) => option.display_name}
          value={value}
          onChange={(_event, newValue) => onChange(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="New role" required size="small" />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={loading || !value}
          startIcon={
            loading ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          <span>{loading ? 'Transferring...' : 'Yes, Transfer Role'}</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HoHTransferDialog;
